if (!customElements.get('hotspot-slider')) {
  class HotspotSlider extends HTMLElement {
    constructor() {
      super();
      this.hotspots = this.querySelectorAll('[data-hotspot-slider-dot]');
      this.emblaId = this.querySelector('embla-carousel').getAttribute('id');

      this.init();
    }

    init() {
      this.hotspots.forEach((hotspot, index) => {
        if (index === 0) {
          hotspot.classList.add('active');
        }

        hotspot.addEventListener('click', () => {
          if (window.emblaApi[this.emblaId]) {
            window.emblaApi[this.emblaId].scrollTo(index);
          }
        });

        if (this.emblaId && window.emblaApi[this.emblaId]) {
          window.emblaApi[this.emblaId].on('select', () => {
            this.hotspots.forEach((hotspot, index) => {
              hotspot.classList.toggle('active', index === window.emblaApi[this.emblaId].selectedScrollSnap());
            });
          });
        }
      });
    }
  }

  customElements.define('hotspot-slider', HotspotSlider);
}
